import request from '@/utils/request'
// 会员等级列表
export function memberLevel(data) {
  return request({
    url: 'oiluserlevel/index',
    method: 'get',
    params: data
  })
}
// 会员等级选项
export function levelOption(data) {
  return request({
    url: 'oiluserlevel/option',
    method: 'get',
    params: data
  })
}

// 会员等级详情选项
export function levelParams() {
  return request({
    url: 'oiluserlevel/params',
    method: 'get'
  })
}

// 添加会员等级
export function addMemberlevel(data) {
  return request({
    url: 'oiluserlevel/add',
    method: 'post',
    params: data
  })
}

// 编辑会员等级
export function editMemberlevel(data) {
  return request({
    url: 'oiluserlevel/edit',
    method: 'post',
    params: data
  })
}

// 删除会员等级
export function delMemberlevel(data) {
  return request({
    url: 'oiluserlevel/del',
    method: 'get',
    params: data
  })
}

// 会员统计信息
export function userCount(data) {
  return request({
    url: 'oiluser/statistics',
    method: 'get',
    params: data
  })
}
// 会员列表
export function userList(data) {
  return request({
    url: 'oiluser/index',
    method: 'get',
    params: data
  })
}

// 门店会员
export function storeUser(data) {
  return request({
    url: 'oiluser/storeUser',
    method: 'get',
    params: data
  })
}

// 会员详情信息
export function userInfo(data) {
  return request({
    url: 'oiluser/detail',
    method: 'get',
    params: data
  })
}

// 编辑会员基本信息
export function userEdit(data) {
  return request({
    url: 'oiluser/edit',
    method: 'post',
    params: data
  })
}

// 删除会员
export function userDel(data) {
  return request({
    url: 'oiluser/del',
    method: 'delete',
    params: data
  })
}

// 会员加油订单
export function userOilOrder(data) {
  return request({
    url: 'oiluser/orderList',
    method: 'get',
    params: data
  })
}

// 会员商品订单
export function userGoodsOrder(data) {
  return request({
    url: 'oiluser/goodsOrderList',
    method: 'get',
    params: data
  })
}

// 会员卡券列表
export function userCouponList(data) {
  return request({
    url: 'oiluser/couponList',
    method: 'get',
    params: data
  })
}

// 会员储值列表
export function userMoneyLog(data) {
  return request({
    url: 'oiluser/moneyLog',
    method: 'get',
    params: data
  })
}

// 会员积分信息
export function userScoreLog(data) {
  return request({
    url: 'oiluser/scoreLog',
    method: 'get',
    params: data
  })
}

// 会员加油金列表
export function useroilMoneyList(data) {
  return request({
    url: 'oiluser/oilMoneyList',
    method: 'get',
    params: data
  })
}

// 下载会员导入模板
export function downMemberImportTemp() {
  return request({
    url: 'upload/downImportStoreUserTemp',
    method: 'get'
  })
}

// 导入门店会员
export function importMember(params) {
  return request({
    url: 'upload/importStoreUser',
    method: 'post',
    params
  })
}
